import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { addDays, format, startOfWeek } from "date-fns";
import { es } from "date-fns/locale";
import { Printer } from "lucide-react";
import { api, TIPOS_CITA } from "@/lib/api";

const ymd = (d) => format(d, "yyyy-MM-dd");

export default function AgendaImprimirSemana() {
  const [sp, setSp] = useSearchParams();
  const lunes = startOfWeek(new Date(`${sp.get("fecha")}T12:00`), { weekStartsOn: 1 });
  const dias = Array.from({ length: 6 }, (_, i) => addDays(lunes, i));
  const [profs, setProfs] = useState([]);
  const [appts, setAppts] = useState(null);
  const pid = sp.get("prof") || profs[0]?.id;
  useEffect(() => {
    api.get("/profesionales").then((r) => setProfs(r.data));
  }, []);
  useEffect(() => {
    api.get("/appointments", { params: { desde: ymd(dias[0]), hasta: ymd(dias[5]) } }).then((r) => setAppts(r.data.filter((a) => a.estado !== "anulada")));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sp.get("fecha")]);
  const p = profs.find((x) => x.id === pid);
  if (!appts || !p) return <p className="p-8 text-sm text-slate-500">Cargando…</p>;
  const mias = appts.filter((a) => a.profesional_id === pid);
  return (
    <div className="bg-white p-6 print:p-0" data-testid="agenda-imprimir-semana">
      <style>{"@media print { @page { size: A4 landscape; margin: 10mm; } }"}</style>
      <div className="mb-4 flex flex-wrap items-center gap-3 print:hidden">
        <select className="field-select w-64" value={pid} onChange={(e) => setSp({ fecha: sp.get("fecha"), prof: e.target.value })} data-testid="imprimir-semana-prof">
          {profs.map((x) => <option key={x.id} value={x.id}>{x.nombre}</option>)}
        </select>
        <button type="button" onClick={() => window.print()} data-testid="imprimir-semana-btn" className="inline-flex items-center gap-2 rounded-md bg-[#1E3A8A] px-4 py-2 text-sm font-medium text-white hover:bg-[#1E40AF]"><Printer className="h-4 w-4" />Imprimir</button>
      </div>
      <h1 className="mb-3 flex items-center gap-2 text-lg font-bold">
        <span className="h-3.5 w-3.5 rounded-sm" style={{ background: p.color }} />{p.nombre} · semana del {format(dias[0], "d 'de' MMMM", { locale: es })} al {format(dias[5], "d 'de' MMMM yyyy", { locale: es })}
      </h1>
      <div className="grid grid-cols-6 gap-2">
        {dias.map((d) => {
          const citas = mias.filter((a) => a.fecha === ymd(d)).sort((x, y) => x.inicio.localeCompare(y.inicio));
          return (
            <div key={ymd(d)} className="rounded border border-slate-300" data-testid={`semana-dia-${ymd(d)}`}>
              <div className="border-b border-slate-300 bg-slate-100 px-2 py-1 text-xs font-bold first-letter:uppercase">{format(d, "EEEE d", { locale: es })}</div>
              {citas.length ? citas.map((a) => (
                <div key={a.id} className="border-b border-slate-200 px-2 py-1 text-[11px] leading-tight">
                  <b>{a.inicio}–{a.fin}</b> <span className="text-slate-500">{a.tipo !== "otro" ? TIPOS_CITA[a.tipo]?.label : ""}</span>
                  <div>{a.patient?.nombre || a.titulo}{a.patient?.codigo ? ` · nº ${a.patient.codigo}` : ""}</div>
                  {a.patient && a.titulo && <div className="text-slate-500">{a.titulo}</div>}
                </div>
              )) : <p className="px-2 py-2 text-[11px] text-slate-400">Sin citas</p>}
            </div>
          );
        })}
      </div>
    </div>
  );
}
